/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 3bda4ef98b93c30afde6c7073b54117eccb7efb3ff9dd256c363ec67957859f4
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './NavDivider.style'

type NavDividerOwnProps = {
  className?: string
}

export type NavDividerProps = NavDividerOwnProps & Omit<ComponentProps<'hr'>, keyof NavDividerOwnProps | 'children'>

function NavDivider(props: NavDividerProps): ReactElement {
  const {
    className = '',
    ...rest
  } = props

  return (
    <hr
      className={cn('NavDivider', className)}
      css={style}
      {...rest}
    />
  )
}

export default NavDivider
